module.exports = __webpack_public_path__ + "static/media/diagram-lifecycle-of-an-emotion.8dd8e834.png";